import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IState } from "../interfaces/state";

@Injectable({
  providedIn: 'root'
})
export class StateService {
  private rootUrl: string = "/api/states";

  constructor(private httpClient: HttpClient) { }

  public getStates(): Observable<IState[]> {
    const url = this.rootUrl;
    return this.httpClient.get<IState[]>(url);
  }
}
